function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.54 31.08C24.1225 31.08 31.08 24.1225 31.08 15.54C31.08 6.95749 24.1225 0 15.54 0C6.95749 0 0 6.95749 0 15.54C0 24.1225 6.95749 31.08 15.54 31.08Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9498 10.1799C12.1798 10.8699 9.94981 13.04 9.94981 15.11C9.94981 16.59 11.3298 16.7399 12.1198 16.7899C12.3943 16.7801 12.6678 16.827 12.9234 16.9276C13.179 17.0282 13.4111 17.1803 13.6053 17.3745C13.7995 17.5687 13.9516 17.8008 14.0522 18.0564C14.1528 18.312 14.1996 18.5855 14.1898 18.86C14.1916 19.154 14.1333 19.4453 14.0185 19.7159C13.9038 19.9866 13.7349 20.2309 13.5224 20.4341C13.3099 20.6372 13.0582 20.7949 12.7826 20.8973C12.507 20.9998 12.2134 21.0449 11.9198 21.0299C10.1998 21.0299 8.56982 19.45 8.56982 16.84C8.60283 15.2664 9.13069 13.7431 10.0785 12.4866C11.0263 11.23 12.3459 10.304 13.8498 9.83997L13.9498 10.1799ZM21.2498 10.1799C19.4798 10.8699 17.2498 13.04 17.2498 15.11C17.2498 16.59 18.6298 16.7399 19.4198 16.7899C19.6943 16.7801 19.9678 16.827 20.2234 16.9276C20.479 17.0282 20.7111 17.1803 20.9053 17.3745C21.0995 17.5687 21.2516 17.8008 21.3522 18.0564C21.4528 18.312 21.4996 18.5855 21.4898 18.86C21.4916 19.154 21.4333 19.4453 21.3185 19.7159C21.2038 19.9866 21.035 20.2309 20.8224 20.4341C20.6099 20.6372 20.3582 20.7949 20.0826 20.8973C19.807 20.9998 19.5134 21.0449 19.2198 21.0299C17.4898 21.0299 15.8698 19.45 15.8698 16.84C15.9021 15.2676 16.4286 13.7454 17.3745 12.489C18.3203 11.2326 19.6377 10.3058 21.1398 9.83997L21.2498 10.1799Z",
  fill: "black"
});
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.b8658381.svg";
export { ForwardRef as ReactComponent };